import useAuth from "../../../hooks/useAuth";
import {useEffect, useState} from "react";
import {RouteUser} from "../../../routes/RouteUser";

export default function Menu(props) {
    const { menu } = props;

    const { logout } = useAuth();
    const { auth } = useAuth();
    const role = auth ? auth.primaryUser.role : null;

    const linkMyAccount = role === "ROLE_CLIENT" ? RouteUser.MY_ACCOUNT_CLIENT.path : RouteUser.MY_ACCOUNT_WORKER.path
    const linkOrganization = RouteUser.ORGANIZATION.path
    const linkMedia = RouteUser.MEDIA.path

    const [classMenu, setClassMenu] = useState({
        myAccount: "nav-link"
    })

    useEffect(() => {
        if (menu === "my-account"){
            setClassMenu({
                ...classMenu,
                myAccount: "nav-link active"
            })
        }
    }, [menu]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <div className="d-none d-lg-block text-center mb-5">
                <h4 className="card-title">
                    {auth.primaryUser.name} {auth.primaryUser.surnames}
                </h4>
            </div>

            <ul className="nav nav-sub nav-sm nav-tabs nav-list-y-2 mb-4">
                <li className="nav-item">
                    <a
                        className={classMenu.myAccount}
                        href={linkMyAccount}
                    >
                        <i className="fas fa-id-card nav-icon"></i>
                        Mi perfil
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={classMenu.myAccount}
                        href={linkOrganization}
                    >
                        <i className="fas fa-building nav-icon"></i>
                        Organizaciónes
                    </a>
                </li>
                <li className="nav-item">
                    <a
                        className={classMenu.myAccount}
                        href={linkMedia}
                    >
                        <span className="material-icons nav-icon">description</span>
                        Documentación
                    </a>
                </li>
                { role === "ROLE_CLIENT" ? <Clients menu={menu}/> : "" }
                { role === "ROLE_WORKER" ? <Workers menu={menu}/> : "" }
            </ul>

            <div>
                <div className="dropdown-divider"></div>

                <ul className="nav nav-sub nav-sm nav-list-y-2">
                    <li className="nav-item">
                        <button
                            className="nav-link btn btn-link"
                            onClick={logout}
                        >
                            <i className="fas fa-sign-out-alt nav-icon"></i>
                            Cerrar sesión
                        </button>
                    </li>
                </ul>
            </div>
        </>
    );
}

function Clients(props) {
    const { menu } = props;

    const [classMenu, setClassMenu] = useState({
        calendar: "nav-link",
        invoice: "nav-link",
    })

    useEffect(() => {
        if (menu === "calendar"){
            setClassMenu({
                ...classMenu,
                calendar: "nav-link active",
            })
        }
        if (menu === "invoice"){
            setClassMenu({
                ...classMenu,
                invoice: "nav-link active",
            })
        }
    }, [menu]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <li className="nav-item">
                <a
                    className={classMenu.calendar}
                    href={RouteUser.CLIENT_CALENDAR.path}
                >
                    <i className="fas fa-calendar-alt nav-icon"></i>
                    Calendario
                </a>
            </li>
            <li className="nav-item">
                <a
                    className={classMenu.invoice}
                    href={RouteUser.CLIENT_TRANSACTION.path}
                >
                    <i className="fas fa-receipt nav-icon"></i>
                    Facturas
                </a>
            </li>
        </>
    )
}

function Workers(props) {
    const { menu } = props;

    const [classMenu, setClassMenu] = useState({
        calendar: "nav-link"
    })

    useEffect(() => {
        if (menu === "calendar"){
            setClassMenu({
                ...classMenu,
                calendar: "nav-link active"
            })
        }
    }, [menu]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <>
            <li className="nav-item">
                <a
                    className={classMenu.calendar}
                    href={RouteUser.WORKER_CALENDAR.path}
                >
                    <i className="fas fa-calendar nav-icon"></i>
                    Calendario
                </a>
            </li>
        </>
    )
}
